const roundCoordinate = (value) => Number(value).toFixed(6)

const normalizeKeyPart = (value) => String(value || '').trim().toLowerCase()

const buildFacilityKey = (offering) => {
  const lat = Number(offering?.coordinates?.lat)
  const lng = Number(offering?.coordinates?.lng)
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null

  return [
    roundCoordinate(lat),
    roundCoordinate(lng),
    normalizeKeyPart(offering?.venueName),
    normalizeKeyPart(offering?.coachFacilityFullAddress),
  ].join('|')
}

export const groupOfferingsByFacility = (offerings = []) => {
  const grouped = new Map()

  offerings.forEach((offering) => {
    const key = buildFacilityKey(offering)
    if (!key) return

    const lat = Number(offering?.coordinates?.lat)
    const lng = Number(offering?.coordinates?.lng)
    if (!grouped.has(key)) {
      grouped.set(key, {
        key,
        position: { lat, lng },
        venueName: offering?.venueName || 'PGA Coaching Facility',
        offerings: [],
      })
    }
    grouped.get(key).offerings.push(offering)
  })

  return Array.from(grouped.values())
}

export const formatDistanceMiles = (distanceMeters) => {
  const meters = Number(distanceMeters)
  if (Number.isNaN(meters) || meters <= 0) return ''
  const miles = meters / 1609.344
  const rounded = miles >= 10 ? Math.round(miles) : Math.round(miles * 10) / 10
  return `${rounded} mi`
}

/** Middot separators for map popup facility line (replaces spaced ASCII hyphens). */
const MAP_POPUP_FACILITY_SEP = ' \u2022 '

/**
 * Venue + distance line for map popup list rows.
 * Spaced hyphens in Algolia venue strings become middots; distance appends with the same separator.
 */
export const formatMapPopupFacilityLine = ({
  venueName,
  facilityName,
  distanceLabel,
} = {}) => {
  const base = String(venueName || facilityName || '').trim()
  const normalizedBase = base.replace(/\s-\s/g, MAP_POPUP_FACILITY_SEP)
  const dist = distanceLabel != null && String(distanceLabel).trim() !== ''
    ? String(distanceLabel).trim()
    : ''
  if (dist && normalizedBase) return `${normalizedBase}${MAP_POPUP_FACILITY_SEP}${dist}`
  if (dist) return dist
  return normalizedBase
}

export const formatOfferingTypeLabel = (format) => {
  const normalized = String(format || '').trim().toLowerCase()
  if (!normalized) return 'Program'
  if (normalized === 'private') return 'Private'
  if (normalized === 'group' || normalized === 'group_clinic') return 'Group'
  if (normalized === 'program') return 'Program'
  return normalized.charAt(0).toUpperCase() + normalized.slice(1)
}
